function blockRequestDemo() {
  function init() {
    setup();
    //addEventListeners();

  }
  function setup() {
    const list = jQuery(".block-request-demo");
    for (let index = 0; index < list.length; index++) {
      const element = jQuery(list[index]);
      const idForm =  element.data("formulario");
      const link =  element.data("link");
      if(!idForm) {
        element.html("<div class='block-request-demo__no-data'>Debes ingresar el id del formario</div>");
        element.addClass("block-request-demo--ready");
        return;
      }
      
      const content = element.find('.block-request-demo__content');
      const button = element.find('.block-request-demo__button');
      const form = jQuery("<form class='block-request-demo__form'>");
      
      const demo = element.find('.block-request-demo__fake');
      demo.remove();
      const createInput = jQuery("<input class='block-request-demo__input' type='email' required>");
      button.attr("type", "submit");
      createInput.attr("placeholder", demo.text());
      content.prepend(createInput);
      form.append(content);
      element.append(form);
      element.addClass("block-request-demo--ready");
      form.attr("data-formulario", idForm);
      form.attr("data-link", link);
      form.on("submit", submitDemo);
    }
  }
  function submitDemo(evt) {
    evt.preventDefault();
    const parent = jQuery(this);
    const form =  parent.data("formulario");
    const link =  parent.data("link");
    const input = parent.find('.block-request-demo__input');
    const jqueryInput = jQuery(input[0]);
    const email = jqueryInput.val();
    if(!isEmail(email)) {
      jqueryInput.addClass('block-request-demo__input--error');
      return;
    }
    jqueryInput.removeClass('block-request-demo__input--error');
    sendForm(form, email, link);
    input.val('');
  }
  function sendForm(form, email, link) {
    if(!form) {
      return;
    }
    const urlRedirect = link || urlDemo;
    const urlForm = `${window.home}/wp-json/contact-form-7/v1/contact-forms/${form}/feedback`;
    const formData = new FormData();

    formData.append('_wpcf7', form);
    formData.append('_wpcf7_version', "5.5.6.1");
    formData.append('_wpcf7_container_post', 0);
    formData.append('_wpcf7_posted_data_hash', '');
    formData.append('your-email', email);
    jQuery.ajax({
      type: "POST",
      url: urlForm,
      data: formData,
      processData: false,
      contentType: false,
      success: function(res) {

        window.open(urlRedirect, '_blank');
      },
      error: function (error) {
        window.open(urlRedirect, '_blank');
      }
    });
  }
  function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  }
  init();
}
blockRequestDemo();